var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OnlineTestWiseAnalysis',{attrs:{"testType":"aits","studentId":_vm.student_id,"batchId":_vm.batch_id}})}
var staticRenderFns = []

export { render, staticRenderFns }